import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { UserContext } from '../App';
import { useClientUser } from '@/hooks/useClientUser';
import { resolveFinancialsAccess } from './accessControl';

// Guards the carrier financials pages (Receivables / Payables). Unlike withAdminRights
// (Onward-internal tools, admins only), this also admits carrier admins — matching who
// the sidebar Accounting menu shows those links to. See accessControl.resolveFinancialsAccess.
const withFinancialsRights = (Component) => (props) => {
    const navigate = useNavigate();

    const { user, client } = useContext(UserContext);
    const { isCarrierAdmin } = useClientUser();
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        const access = resolveFinancialsAccess({ user, client, isCarrierAdmin });
        if (access === 'allow') {
            setAuthorized(true);
        } else if (access === 'deny') {
            navigate('/account');
        }
    }, [user, client, isCarrierAdmin]);

    return authorized ? <Component {...props} /> : null;
};

export default withFinancialsRights;
